function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.5
}, React.createElement("path", {
  d: "M37.588.1H4.548A4.454 4.454 0 00.1 4.548v29.228a4.454 4.454 0 004.448 4.448h33.04a.635.635 0 00.635-.635V.735A.635.635 0 0037.588.1zM1.371 30.666V4.548a3.181 3.181 0 013.177-3.177h32.405v27.957H4.548a4.389 4.389 0 00-3.141 1.3zm35.582 6.287H4.548a3.177 3.177 0 110-6.354h32.405zm0 0"
}), React.createElement("path", {
  d: "M5.183 33.141h26.052a.635.635 0 000-1.271H5.183a.635.635 0 000 1.271zm0 0M8.36 35.046a.635.635 0 00.635.635h26.051a.635.635 0 100-1.271H8.995a.635.635 0 00-.635.636zm0 0M7.724 26.786H33.14a.639.639 0 00.217-.044.516.516 0 00.053-.021c.013-.006.027-.009.04-.016a.554.554 0 00.06-.051.651.651 0 00.1-.088.58.58 0 00.063-.1.6.6 0 00.056-.109.637.637 0 00.025-.127.6.6 0 00.019-.081v-21.6a.635.635 0 00-.635-.635H7.724a.635.635 0 00-.635.635v21.6a.635.635 0 00.635.637zm12.277-1.274l-2.126-3.261 6.354-10.717 7.827 13.978zm-1.517 0h-9.69l4.667-7.7zm14.02-20.333v18.533L24.799 9.956a.635.635 0 00-.546-.325.585.585 0 00-.555.311l-6.6 11.126-3.126-4.795a.645.645 0 00-.543-.289.636.636 0 00-.532.306l-4.54 7.491v-18.6zm0 0"
}), React.createElement("path", {
  d: "M17.256 12.808a2.542 2.542 0 10-2.542-2.541 2.542 2.542 0 002.542 2.541zm0-3.812a1.271 1.271 0 11-1.271 1.271 1.271 1.271 0 011.271-1.271zm0 0"
}));

var SvgAlbumIcon = function SvgAlbumIcon(props) {
  return React.createElement("svg", _extends({
    width: 38.324,
    height: 38.324
  }, props), _ref);
};

export default __webpack_public_path__ + "9a6a938d536da3eb61afac63b3ebba0b.svg";
export { SvgAlbumIcon as ReactComponent };